import { render } from "./TeamAdminTools.vue?vue&type=template&id=f3b9c660&scoped=true"
import script from "./TeamAdminTools.vue?vue&type=script&lang=js"
export * from "./TeamAdminTools.vue?vue&type=script&lang=js"

import "./TeamAdminTools.vue?vue&type=style&index=0&id=f3b9c660&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3b9c660"]])

export default __exports__